import * as styles from "./DocumentationNavItem.styles";
import { FontAwesomeIcon } from "@/components/ReactFontAwesome/ReactFontAwesome";
import { Typography } from "@fullscript/aviary-web";
import { faChevronRight, faChevronDown } from "@fortawesome/pro-light-svg-icons";
import { Link } from "@/aviaryTmp/Link/Link";
import { useLocation } from "@remix-run/react";
import { useState, useEffect } from "react";
import { isActiveCategory } from "./isActiveCategory";

export type Category = {
  link: string;
  title: string;
  baseLink?: string;
  subCategories?: Category[];
};

type Props = {
  category: Category;
  isFirstSubCategory?: boolean;
  depth?: number;
  activeHeadingId?: string | null;
};

const DocumentationNavItem = ({
  category,
  isFirstSubCategory,
  depth = 1,
  activeHeadingId,
}: Props) => {
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsActive(
      isActiveCategory({
        activeHeadingId: activeHeadingId || "",
        depth,
        category,
        isFirstSubCategory: isFirstSubCategory || false,
        pathname: location.pathname,
        scrollY: window.scrollY,
      })
    );
  }, [location.pathname, category, activeHeadingId, isFirstSubCategory, depth]);

  if (category.subCategories && category.subCategories.length > 0) {
    const isSubCategoryActive = category.subCategories.some(subCategory => {
      return (
        (subCategory.baseLink && location.pathname.startsWith(subCategory.baseLink)) ||
        location.pathname === subCategory.link
      );
    });

    return (
      <div key={category.title}>
        <Link
          to={category.link}
          isUnderLined={false}
          css={[styles.categoryWithSubsTitleLink, styles.depthPadding(depth)]}
        >
          <Typography
            isMarginless
            customCss={[
              styles.subCategoryTitle,
              isSubCategoryActive && styles.activeSubCategoryTitle,
            ]}
          >
            {category.title}
          </Typography>
          <FontAwesomeIcon icon={isSubCategoryActive ? faChevronDown : faChevronRight} />
        </Link>
        <div
          data-testid="sub-category-list"
          css={[styles.subCategoryList, isSubCategoryActive && styles.subCategoryListActive]}
        >
          {category.subCategories.map((subCategory, index) => (
            <DocumentationNavItem
              key={subCategory.title}
              category={subCategory}
              isFirstSubCategory={index === 0}
              depth={depth + 1}
              activeHeadingId={activeHeadingId || null}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <Link
      key={category.title}
      to={category.link}
      isUnderLined={false}
      css={[styles.category, isActive && styles.activeCategory, styles.depthPadding(depth)]}
    >
      <Typography isMarginless customCss={styles.categoryTitle}>
        {category.title}
      </Typography>
    </Link>
  );
};

export { DocumentationNavItem };
